module.exports = __webpack_public_path__ + "img/1-1.b44d4ce1.svg";